import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const publicApi = axios.create({ baseURL: API });

export const getPasscode = () => sessionStorage.getItem("vp_passcode") || "";
export const getToken = () => sessionStorage.getItem("vp_token") || "";
export const getRole = () => sessionStorage.getItem("vp_role") || "";
export const getUser = () => JSON.parse(sessionStorage.getItem("vp_user") || "null");

export const clearSession = () => ["vp_passcode", "vp_role", "vp_token", "vp_user"].forEach((k) => sessionStorage.removeItem(k));

export const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : { "X-Staff-Passcode": getPasscode() };
};

export const staffApi = () => {
  const inst = axios.create({ baseURL: API, headers: authHeaders() });
  inst.interceptors.response.use(undefined, (err) => {
    if (err?.response?.status === 401 && (getToken() || getPasscode())) {
      clearSession();
      window.location.assign("/staff");
    }
    return Promise.reject(err);
  });
  return inst;
};

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return fallback;
};

export const videoUrl = (id) => `${API}/devotionals/${id}/video`;
export const eventPhotoUrl = (id) => `${API}/public/events/${id}/photo`;
